module.exports = __webpack_public_path__ + "static/media/logo1.b5b14bbf.png";